<template>
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
          v-b-toggle.accordion-1
          name="receiverHeader"
      >
        {{ $t('createShipment.label.Receiver') }} &nbsp;
        <span
            class="small"
            v-if="shipment.receiverAddress.name"
        >
                    {{ shipment.receiverAddress.name }} -
                    {{ shipment.receiverAddress.postalCode }} -
                    {{ shipment.receiverAddress.countryCode }}
                </span>
      </b-card-header>
      <b-collapse
          id="accordion-1"
          accordion="my-accordion"
          role="tabpanel"
          :visible="shipment.shipmentType !== 'Import'"
      >
        <b-card-body>
          <addressCard
              :cardHeaderText="$t('createShipment.label.Receiver')"
              :address="shipment.receiverAddress"
              ref="receiverAddress"
              refPrefix="receiverAddress"
              :saveFlags="shipment.saveFlags"
              :v="v.shipment.receiverAddress"
              :canEdit="true"
              :lockCountry="shipment.shipmentType === 'Import'"
              :showB2C="display(fieldNames.IS_PRIVATE_OR_BUSINESS)"
          />
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
          v-b-toggle.accordion-2
          name="senderHeader"
      >
        {{ $t('createShipment.label.Sender') }} &nbsp;
        <span
            class="small"
            v-if="shipment.senderAddress.name"
        >
                    {{ shipment.senderAddress.name }} - {{ shipment.senderAddress.postalCode }} -
                    {{ shipment.senderAddress.countryCode }}
                </span>
      </b-card-header>
      <b-collapse
          id="accordion-2"
          accordion="my-accordion"
          role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <addressCard
                :cardHeaderText="$t('createShipment.label.Sender')"
                :address="shipment.senderAddress"
                ref="senderAddress"
                refPrefix="senderAddress"
                :saveFlags="shipment.saveFlags"
                :v="v.shipment.senderAddress"
                :canEdit="
                                shipment.shipmentType !== 'Cross' &&
                                    shipment.shipmentType !== 'Import'
                            "
            />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
          v-b-toggle.accordion-3
          name="pickupHeader"
      >
        {{ $t('createShipment.label.Pickup') }} &nbsp;
        <span
            class="small"
            v-if="shipment.pickupAddress.name"
        >
                    {{ shipment.pickupAddress.name }} - {{ shipment.pickupAddress.postalCode }} -
                    {{ shipment.pickupAddress.countryCode }}
                </span>
      </b-card-header>
      <b-collapse
          id="accordion-3"
          accordion="my-accordion"
          role="tabpanel"
          :visible="shipment.shipmentType === 'Import'"
      >
        <b-card-body>
          <b-card-text>
            <addressCard
                :cardHeaderText="$t('createShipment.label.Pickup')"
                :address="shipment.pickupAddress"
                refPrefix="pickupAddress"
                ref="pickupAddress"
                :v="v.shipment.pickupAddress"
                :saveFlags="shipment.saveFlags"
                :canEdit="true"
                :lockCountry="shipment.shipmentType === 'Export'"
            />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1" v-if="showSoldToAddress">
      <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
          v-b-toggle.accordion-4
          name="soldToHeader"
      >
        {{ $t('createShipment.label.SoldTo') }} &nbsp;
        <span
            class="small"
            v-if="shipment.soldToAddress.name"
        >
                    {{ shipment.soldToAddress.name }} - {{ shipment.soldToAddress.postalCode }} -
                    {{ shipment.soldToAddress.countryCode }}
                </span>
      </b-card-header>
      <b-collapse
          id="accordion-4"
          accordion="my-accordion"
          role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <addressCard
                :cardHeaderText="$t('createShipment.label.SoldTo')"
                :address="shipment.soldToAddress"
                refPrefix="soldToAddress"
                ref="soldToAddress"
                :v="v.shipment.soldToAddress"
                :saveFlags="shipment.saveFlags"
                :canEdit="true"
                :show-account-number="true"
                :show-vat-number="true"
                :show-eori-number="true"
                :show-duty-account-number="true"
                :address-book-type="'SoldTo'"
            />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1" v-if="showBrokerAddress">
      <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
          v-b-toggle.accordion-4
          name="brokerAddressHeader"
      >
        {{ $t('createShipment.label.Broker') }} &nbsp;
        <span
            class="small"
            v-if="shipment.brokerAddress.name"
        >
                    {{ shipment.brokerAddress.name }} - {{ shipment.brokerAddress.postalCode }} -
                    {{ shipment.brokerAddress.countryCode }}
                </span>
      </b-card-header>
      <b-collapse
          id="accordion-4"
          accordion="my-accordion"
          role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <addressCard
                :cardHeaderText="$t('createShipment.label.Broker')"
                :address="shipment.brokerAddress"
                refPrefix="brokerAddress"
                ref="brokerAddress"
                :v="v.shipment.brokerAddress"
                :saveFlags="shipment.saveFlags"
                :canEdit="true"
                :show-account-number="true"
                :show-vat-number="true"
                :show-eori-number="true"
                :show-duty-account-number="false"
                :address-book-type="'BrokerSelection'"
            />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import addressCard from './address';
import {EventBus} from '../services/event-bus.js';
import helper from '../helper';
import {EVENTS, FIELD_NAMES} from '../store/nameConstants';
import {MUTATIONS, ACTIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX} from '../store/constants';
import {mapGetters} from 'vuex';
import viewOptions from "@/mixins/viewOptionsMixin";
import localization from "@/mixins/localizationMixin";
import resetMixin from "@/mixins/resetMixin";
export default {
  components: {
    addressCard,
  },
  mixins: [viewOptions],
  props: {
    viewOptions: {required: true},
    shipment: {required: true},
    v: {required: true},
  },
  data(){
    return {
      fieldNames: FIELD_NAMES,
    }
  },
  computed: {
    ...mapGetters('core', ['getShipmentSystemCountryCode']),
    showSoldToAddress() {
      return this.shipment.soldToAddress != null
    },
    showBrokerAddress() {
      return this.shipment.brokerAddress != null
    },
  },
  created() {
    EventBus.$on(EVENTS.SET_RECEIVER, (senderData) => {
      this.shipment.receiverAddress = helper.cloneObject(senderData);
    });
    EventBus.$on(EVENTS.SET_SENDER, (senderData) => {
      this.shipment.senderAddress = helper.cloneObject(senderData);
    });
    EventBus.$on(EVENTS.SET_PICKUP, (senderData) => {
      if (this.shipment.shipmentType === 'Import') {
        this.shipment.receiverAddress = helper.cloneObject(senderData);

        if (this.$refs.pickupAddress !== undefined) {
          this.$refs.pickupAddress.clearAddress();
        }
        return;
      }

      this.shipment.pickupAddress = helper.cloneObject(senderData);
    });

    EventBus.$on(EVENTS.SHIPMENT_TYPE_UPDATE, (senderData) => {
      const receiverAddress = this.shipment.receiverAddress;
      const pickupAddress = this.shipment.pickupAddress;

      if (senderData.to === 'Import') {
          if (pickupAddress.countryCode !== this.getShipmentSystemCountryCode && this.$route.query.import !== 'true') {
          this.$refs.pickupAddress.clearAddress();
          this.shipment.pickupAddress.countryCode = this.getShipmentSystemCountryCode;
        }

        this.shipment.receiverAddress = pickupAddress;
        this.shipment.pickupAddress = receiverAddress;
      }

      if (senderData.from === 'Import') {
        this.shipment.pickupAddress = receiverAddress;
        this.shipment.receiverAddress = pickupAddress;
      }
    });
  },
};
</script>
<style>
.btn-link {
  color: #1f7037;
}
</style>
